import {OrderedSet} from 'immutable';
import {RecordProps, Data} from '@store/@types/util';

export type FilterWordId = string;

interface NewFilterWordProps {
  readonly filterWordId: FilterWordId | undefined;
  readonly word: string;
  readonly topic: boolean;
  readonly trainIntoTranscript: boolean;
  readonly displayWhen: FilterWordDisplayWhen;
  readonly alternateSpellings: OrderedSet<string>;
  readonly includeInInsights: boolean;
  readonly speakerMatch: FilterWordSpeakerMatch;
}

/**
 * A keyword or topic.
 */
export default class NewFilterWord extends Data<NewFilterWordProps>({
  filterWordId: undefined,
  word: undefined,
  topic: false,
  trainIntoTranscript: false,
  displayWhen: undefined,
  alternateSpellings: OrderedSet(),
  includeInInsights: null,
  speakerMatch: undefined,
}) {
  constructor(props: RecordProps<NewFilterWord> = {alternateSpellings: []}) {
    super({
      ...props,
      alternateSpellings: OrderedSet(props.alternateSpellings ?? []),
    });
  }
}

/**
 * Enumeration of sidebar display options.
 */
export enum FilterWordDisplayWhen {
  ALWAYS = 'ALWAYS',
  WHEN_SEARCHED = 'WHEN_SEARCHED',
  WHEN_FOUND = 'WHEN_FOUND',
}

/**
 * Enumeration of speaker matching options.
 */
export enum FilterWordSpeakerMatch {
  /** Match any speaker. */
  ALL = 'ALL',
  /** Match only identified internal speakers. */
  INTERNAL = 'INTERNAL',
  /**
   * Match external speakers.
   *
   * This usually means external/unidentified speakers, except in triggers for bot calls, where it means only external
   * identified speakers.
   */
  EXTERNAL = 'EXTERNAL',
}
